export type IErrorResponse = {
  message: string;
  name: string;
  stack: string;
  config: {
    transitional: {
      silentJSONParsing: boolean;
      forcedJSONParsing: boolean;
      clarifyTimeoutError: boolean;
    };
    adapter: string[];
    transformRequest: Array<((data: unknown) => unknown) | null>;
    transformResponse: Array<((data: unknown) => unknown) | null>;
    timeout: number;
    xsrfCookieName: string;
    xsrfHeaderName: string;
    maxContentLength: number;
    maxBodyLength: number;
    env: Record<string, unknown>;
    headers: {
      Accept: string;
      "Content-Type": string;
      Authorization: string;
    };
    baseURL: string;
    method: string;
    url: string;
    data: string;
  };
  code: string;
  status: number;
};

import axios, { AxiosError } from "axios";

// Extracts a human-friendly message from typical API error shapes
export function getErrorMessage(err: unknown, fallback = "Ocorreu um erro inesperado."): string {
  if (axios.isAxiosError(err)) {
    const axErr = err as AxiosError<any>;
    const data = axErr.response?.data;

    // 1) Array of { field, message }
    if (Array.isArray(data?.errors) && data.errors.length > 0) {
      const msgs = data.errors
        .map((e: any) => e?.message)
        .filter(Boolean)
        .join(" | ");
      if (msgs) return msgs;
    }

    // 2) { error: { message } } or { error: { error } }
    if (data?.error?.message) return String(data.error.message);
    if (data?.error?.error) return String(data.error.error);

    // 3) plain { message }
    if (data?.message) return String(data.message);
  }

  // 4) Last resort
  return fallback;
}

// Returns all messages individually for multiple toasts
export function getErrorMessages(err: unknown): string[] {
  const result: string[] = [];
  if (axios.isAxiosError(err)) {
    const axErr = err as AxiosError<any>;
    const data = axErr.response?.data;

    if (Array.isArray(data?.errors) && data.errors.length > 0) {
      data.errors.forEach((e: any) => {
        if (e?.message) result.push(String(e.message));
      });
    } else if (data?.error?.message) {
      result.push(String(data.error.message));
    } else if (data?.error?.error) {
      result.push(String(data.error.error));
    } else if (data?.message) {
      result.push(String(data.message));
    }
  }
  return result;
}